enum MESSAGE_STATUS {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warn',
  ERROR = 'error',
}

export default MESSAGE_STATUS